import {firebase, googleAuthProvider} from "../firebase/firebase";

export const googleLogin = () => {
    return () => {
        return firebase.auth().signInWithPopup(googleAuthProvider);
    }
};

export const killSession = () => {
    return () => {
        return firebase.auth().signOut();
    }
};

export const login = (uid) => ({
    type: "LOGIN",
    uid
});

export const logout = () => ({
    type: "LOGOUT"
});